export class LocalizationLanguageApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getActiveLocalizationLanguages({ signal } = {}) {
    return this.#http.get('/api/localization/languages/active', { signal });
  }
}
